import React, { useState } from "react";
import styles from "./Casefile.module.scss";
import CloseButton from "../Static assets/Crosses/Cross-01.png";

function Unmoderated(props) {
  const setSelected = props.setSelected;
  return (
    <div className={styles.queryBox}>
      <img
        className={styles.close}
        src={CloseButton}
        onClick={(event) => {
          setSelected(null);
        }}
      />
      <p className={styles.moderated}>
        This post has not yet been moderated! Comments are moderated several
        times a week by hard working staff at FACT, so check back soon!
      </p>
    </div>
  );
}

export default Unmoderated;
